module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-user-avatar"
  }, [_c('div', {
    staticClass: "bg-d"
  }, [(_vm.showAvatar) ? _c('div', {
    staticClass: "bg-c",
    style: ({
      backgroundImage: 'url(' + _vm.userIcon + ')'
    })
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c37b0f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-avatar.vue
// module id = 849
// module chunks = 2